/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 */
import React, { lazy, Suspense } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../Banner/Banner.css";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu/index";
const Form = lazy(() => import("../../components/SignUpForm/SignUpForm"));

export default function Body({ links }) {

  return (
    <>
      <div className="banner">
        <Container className="bannercontainer">
          <Row>
            <div className="userway-div-mobile">
        <UserWayAccessibilityMenu color="white" width={40} height={40} />
        </div>

            <Col sm={12} md={12} xl={7} lg={7} xxl={7}>
              <div className="bannertextstag">
                <div className="titlestag">
                  <b><p className="mastertitle"><span className="finance-text">Finance On Demand </span><span className="finance-text-mob">Finance On<br /> Demand </span><br></br><span className="aibroker">Ai Brokers Are the Best</span><span className="aibroker-mob">Ai Brokers Are<br />the Best</span></p></b>
                </div>
                <div className="caltext-div">
                <p className="flueltext">
                <span style={{color:"#EE6124"}}>California Mortgage Expo Highlights: </span>
              <br className="mappingtext" />Mapping The Next Frontier</p> 
              </div>
                <div className="relive-text relivetext-desk">
                 <p>Relive the excitement of the California Mortgage Expo in Irvine where real estate professionals gathered to gain from innovation and insights. Sun West's session, 'The Rise of Ai - The Future of Mortgage', shined with its focus on the revolutionary impact of AngelAi on the real estate landscape.</p>
                </div>
              </div>
            </Col>
            <Col sm={12} md={12} xl={5} lg={5} xxl={5}>
              <div className="formsection formdesk">
                <Suspense fallback={<div />}>
                  <Form />
                </Suspense>
              </div>
              <div className="relive-text relivetext-mb">
                 <p>Relive the excitement of the California Mortgage Expo in Irvine where real estate professionals gathered to gain from innovation and insights. Sun West's session, 'The Rise of Ai - The Future of Mortgage', shined with its focus on the revolutionary impact of AngelAi on the real estate landscape.</p>
                </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
